<template>
  <v-container class="fill-height" style="opacity:0.9" fluid>
    <v-row justify="center">
      <v-col cols="8">
        <v-toolbar color="primary" flat>
          <v-toolbar-title>Frequently Asked Questions</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-expansion-panels popout>
          <v-expansion-panel v-for="(item, i) in items" :key="i">
            <v-expansion-panel-header>{{ item.q }}</v-expansion-panel-header>
            <v-expansion-panel-content align="left">
              {{ item.ans }}
              <ol>
                <li v-for="(step, i) in item.steps" :key="i">
                  {{ step }}
                </li>
              </ol>
              <v-text class="text-caption ma-5">{{ item.note }}</v-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      source: String
    },
    data() {
      return {
        items: [
          {
            q: 'How the planetarium software works?',
            ans: `Planetarium software communicates to API servers to show realtime location 
          of stars in sky and shows actual coordinates of stars. The planetarium software 
          reiles on 3rd party servers to remain integral in data communication.`
          },
          {
            q: 'How admin panel works?',
            ans: `Admin panel is management portal for space-registry software. Here we manage 
          our quality services to our customers by guarranteed on time support. The sole purpose
          of this portal is to ensure quality service and in time management of all the registries`
          },
          {
            q: 'How to register a star?',
            ans: `Once you are logged in, you will be redirected to respective page. 
          Manually, you can follow bellow steps to do the same.`,
            steps: [
              'Open sidepanel or navigation panel by hovering over left edge of screen.',
              'Click on "Registry Editor".',
              'On next page, fill in required details (follow format specified below each field, ignore the first search bar).',
              'Click on "Register".',
              'A dialog box will popup with result stats.',
              'Registered details will be shown to you (if successful)',
              'Error details will be shown to you (if failed)',
              'If successful, you can click on "VIEW IN SOFTWARE" below star details to view star in real time'
            ],
            note: `*NOTE: Star registry is an overwrite operation, If the registry number already exists
          it will overwrite the registry with new details.`
          },
          {
            q: 'I accidently registered wrong star details, what should I do?',
            ans: `Star registration is a tiring process, we may make mistakes doing the job! 
          Don't worry we got your back:) In case you accidently wronged the information 
          of registry. Just follow  below steps to update the registry.`,
            steps: [
              'Goto "Registry Editor" (Where you registered the star first)',
              'In "Registry Editor" form, there will be a search bar on top (the one inside the registry form)',
              'Type exact registry number in search bar (any case)',
              'Either press "Enter" key, or Click on "Search" icon next to it',
              'If the registry number is valid, the entire form will be filled automatically (registry details)',
              'If the registry number is invalid, appropriate message will pop up.',
              'If the form is filled, correct the details.',
              'Press "Register", to save the changes again'
            ]
          },
          {
            q: 'What if I need to register 100s of stars?',
            ans: `The solution to this overwhelming problem is very simple. You can head over to Bulk Registry! Just follow below steps to get it right.`,
            steps: [
              'Open sidepanel or navigation panel by hovering over left edge of screen.',
              'Click on "Bulk Registry".',
              'On next page, click on "Download Format".',
              'A file named "stars.csv" should be downloaded to your computer.',
              'Open the file and fill in star details according to headers on top.',
              'Do not alter the first (header) line.',
              'Once done, select the CSV file in requested field.',
              'Once uploaded, click "BULK REGISTRY" to begin the process.',
              'The result stats will be shown in dialog box, after operation is complete.',
              'If you have errors, it will notify you!',
              'Otherwise, an appropriate message will be displayed!'
            ],
            note: `*NOTE: Star registry is an overwrite operation, If the registry number already exists
          it will overwrite the registry with new details.`
          },
          {
            q: 'How to add new stars in database?',
            ans: `If you ever feel lacking on stars, we can always add new stars in our database. Just follow below steps to get it right.`,
            steps: [
              'Open sidepanel or navigation panel by hovering over left edge of screen.',
              'Click on "Add New Stars".',
              'On next page, enter star name (exact) and click on "Search Icon".',
              'Below text box (SkySource) will be filled with star details, only if it exists',
              'You can also add "Internal Name" to star (*optional: will be used in system)',
              'Click on "Add To Database"',
              'The message will be shown, after operation is complete.',
              'You can now check star in "Star Details" menu, (if successful)',
              'If you have errors, it will notify you!',
              'Otherwise, an appropriate message will be displayed!'
            ],
            note: `*NOTE: Adding Stars an overwrite operation, If the Star already exists in database,
          it will overwrite the registry with new details.`
          },
          {
            q: 'How bulk registry works?',
            ans: `Bulk Registry communicates to our api, the api validates the call and acts accordingly!
          If your star details are not in correct format, then it will throw exception and appropriate messages
          will be shown to the end user.`
          },
          {
            q: 'I am getting errors in bulk registry, why?',
            ans: `Bulk registry shows complete result stats! You should check the messages displayed. 
          The messages should describe the problem in detail!`
          },
          {
            q: 'I am not able to register a star, why?',
            ans: `The possible cause is you might have wronged the format of registry! 
          Kindly check the messages shown when operation is performed!`
          },
          {
            q: 'Is star registry an automation process?',
            ans: `Star registry is an autmated process to some extent. 
          The portal is always needed if the automation fails! 
          To edit and update registry data, when required:)`
          }
        ]
      }
    }
  }
</script>

<style></style>
